import { AirportLocation } from '@reward-platform/flights-schemas'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useNotification } from '~/context/notification'
import { getAirports } from '~/services/locationService'
import { GenericClientError } from '~/utils/errors'
import { usePlatformConfig } from '~/context/platform'

const useGetAirport = (airportCode?: string): AirportLocation | undefined => {
  const { addErrorCodeNotification } = useNotification()

  const { opCo } = usePlatformConfig()
  const { data, error, isError } = useQuery({
    queryKey: ['getAirport', airportCode],
    queryFn: async () => {
      if (!airportCode) {
        return undefined
      }
      const airports = await getAirports(opCo, airportCode)
      if (!airports) {
        throw new Error(`Airport not found`)
      }
      return airports[0]
    },
    enabled: !!airportCode,
  })

  useEffect(() => {
    if (isError && error instanceof GenericClientError) {
      addErrorCodeNotification('FLIGHTS_AIRPORT_ERROR', {
        type: 'ERROR',
        errorCode: error.code,
        statusCode: error.httpStatus,
      })
    }
  }, [isError, error, addErrorCodeNotification])

  return data
}

export default useGetAirport
